/* mm-sektions-polish.js
 * 02.09.2026: gezielte Typografie-Korrekturen. Alle Überschriften der
 * Zutaten-Sektion sind groß, kräftig und statisch; nur der Titel
 * "Mehr Energie ... 3 Steps" blendet einmal beim Hinsehen ein.
 * Keine Animation von Produktangaben. Service & Logistik nutzt die
 * Marken-Typografie und kompakte, aufklappbare Statistikkarten.
 */
(function () {
  'use strict';

  var script = document.currentScript;
  if (!script || !/mm-sektions-polish\.js/.test(script.src || '')) {
    var scripts = document.scripts;
    for (var i = scripts.length - 1; i >= 0; i -= 1) {
      if (/mm-sektions-polish\.js/.test(scripts[i].src || '')) {
        script = scripts[i];
        break;
      }
    }
  }
  var src = script && script.src || '';
  var base = src ? src.slice(0, src.lastIndexOf('/') + 1) : '/cdn/shop/assets/';
  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (error) {}

  function addStyle() {
    if (document.getElementById('mm-sektions-polish-style')) return;
    var style = document.createElement('style');
    style.id = 'mm-sektions-polish-style';
    style.textContent =
      '@font-face{font-family:"MM Poppins Black";src:url("' + base +
        'mm-poppins-black.woff2") format("woff2");font-weight:900;font-style:normal;font-display:swap}' +
      '@font-face{font-family:"MM Bricolage ExtraBold";src:url("' + base +
        'mm-bricolage-extrabold.woff2") format("woff2");font-weight:800;font-style:normal;font-display:swap}' +
      '.mmIngredientHeading,.mmIngredientHeading *,.mmWheatHeading,.mmWheatHeading *{' +
        'font-family:"MM Poppins Black","Poppins","Bricolage Grotesque",sans-serif!important;' +
        'font-size:clamp(1.9rem,5vw,2.65rem)!important;font-weight:900!important;line-height:1!important;' +
        'letter-spacing:-.045em!important;text-transform:uppercase!important}' +
      '.mmIngredientSectionHeading,.mmIngredientSectionHeading *{' +
        'font-family:"MM Poppins Black","Poppins","Bricolage Grotesque",sans-serif!important;' +
        'font-size:clamp(1.32rem,6.6vw,1.625rem)!important;font-weight:900!important;line-height:1.05!important;' +
        'letter-spacing:.01em!important;text-transform:uppercase!important;text-wrap:balance!important}' +
      '.mmIngredientSectionHeading .mmIngredientTitleLine{' +
        'display:block!important;white-space:nowrap!important}' +
      '@media(min-width:720px){.mmIngredientSectionHeading,.mmIngredientSectionHeading *{' +
        'font-size:1.35rem!important;white-space:nowrap!important}}' +
      '.mmStepsModern{font-family:"MM Poppins Black","Poppins","Bricolage Grotesque",sans-serif!important;' +
        'font-weight:900!important;line-height:1.02!important;letter-spacing:-.052em!important}' +
      '.mmStepsModern .st_hiw-highlight{font-family:inherit!important;font-weight:inherit!important;' +
        'letter-spacing:inherit!important;color:#FF704A!important}' +
      '.mmStepsMotionPending{opacity:0;transform:translateY(15px);' +
        'transition:opacity .66s cubic-bezier(.22,.61,.36,1),transform .66s cubic-bezier(.22,.61,.36,1)}' +
      '.mmStepsMotionPending .st_hiw-highlight{display:inline-block!important;opacity:0;transform:translateX(-9px);' +
        'transition:opacity .55s cubic-bezier(.22,.61,.36,1) .16s,' +
        'transform .55s cubic-bezier(.22,.61,.36,1) .16s}' +
      '.mmStepsMotionPending.mmStepsMotionIn{opacity:1;transform:none}' +
      '.mmStepsMotionPending.mmStepsMotionIn .st_hiw-highlight{opacity:1;transform:none}' +
      '@media(prefers-reduced-motion:reduce){.mmStepsMotionPending,.mmStepsMotionPending .st_hiw-highlight{' +
        'opacity:1!important;transform:none!important;transition:none!important}}' +

      /* Zutaten-Section: weicher Marken-Mesh statt grellem Gelb-Gruen. */
      '.mmIngredientGradient>[class*="feature-template-"]{' +
        'background-color:#FFE9DC!important;' +
        'background-image:radial-gradient(ellipse at 8% 7%,rgba(255,75,126,.30) 0%,' +
        'rgba(255,75,126,.12) 29%,transparent 52%),' +
        'radial-gradient(ellipse at 92% 13%,rgba(255,112,74,.34) 0%,' +
        'rgba(255,180,90,.16) 31%,transparent 54%),' +
        'radial-gradient(ellipse at 13% 88%,rgba(80,226,170,.28) 0%,' +
        'rgba(80,226,170,.10) 34%,transparent 56%),' +
        'linear-gradient(135deg,#FFF2F7 0%,#FFE8D2 40%,#FFF4B8 68%,#DFFFD5 100%)!important;' +
        'background-repeat:no-repeat!important;background-size:cover!important}' +

      /* Service & Logistik: kompakter Markenblock statt langer grauer Textkarten. */
      '.mmServiceLogistik{--mmSvcBg:#151013;--mmSvcCard:#1E1519;--mmSvcText:#F3E9EC;' +
        '--mmSvcPink:#FF4B7E;--mmSvcRed:#E5142A;--mmSvcOrange:#FF704A;' +
        'background:var(--mmSvcBg)!important;color:var(--mmSvcText);overflow-x:clip}' +
      '.mmServiceLogistik .st_benefits-stats-wrapper{position:relative;isolation:isolate;' +
        'padding:clamp(2.1rem,5vw,4rem) clamp(1rem,4vw,2.75rem)!important;' +
        'background:radial-gradient(circle at 8% 0%,rgba(255,75,126,.17),transparent 34%),' +
        'radial-gradient(circle at 94% 100%,rgba(255,112,74,.12),transparent 32%),' +
        'var(--mmSvcBg)!important;overflow:hidden!important}' +
      '.mmServiceLogistik .st_benefits-stats-wrapper:before{content:"";position:absolute;' +
        'inset:0;z-index:-1;pointer-events:none;opacity:.34;' +
        'background:linear-gradient(115deg,transparent 22%,rgba(255,255,255,.045) 50%,transparent 76%)}' +
      '.mmServiceLogistik .st_benefits-stats-container{max-width:1180px!important;' +
        'position:relative;z-index:1}' +
      '.mmServiceLogistik .st_benefits-stats-title{' +
        'font-family:"Bricolage Grotesque","MM Poppins Black",sans-serif!important;' +
        'font-size:clamp(2.45rem,5.8vw,4.6rem)!important;font-weight:800!important;' +
        'line-height:.94!important;letter-spacing:-.062em!important;text-transform:uppercase!important;' +
        'text-align:left!important;text-wrap:balance!important;color:var(--mmSvcText)!important;' +
        'margin:0 0 clamp(1.5rem,3.5vw,2.5rem)!important}' +
      '.mmServiceLogistik .st_benefits-stats-title:before{content:"";display:block;width:56px;height:4px;' +
        'border-radius:999px;margin:0 0 14px;background:linear-gradient(96deg,var(--mmSvcPink),var(--mmSvcOrange));' +
        'box-shadow:0 0 18px rgba(255,75,126,.32)}' +
      '.mmServiceLogistik .st_benefits-stats-title span{font:inherit!important;color:inherit!important}' +
      '.mmServiceLogistik .st_benefits-stats-title em{font:inherit!important;font-style:normal!important;' +
        'background:linear-gradient(96deg,var(--mmSvcPink),var(--mmSvcOrange));' +
        '-webkit-background-clip:text;background-clip:text;color:transparent!important}' +
      '.mmServiceLogistik .st_benefits-stats-title .highlight:after{display:none!important}' +
      '.mmServiceLogistik .st_benefits-stats-grid{display:grid!important;' +
        'grid-template-columns:repeat(3,minmax(0,1fr))!important;gap:16px!important;' +
        'align-items:start!important;margin:0!important}' +
      '.mmServiceLogistik .st_benefits-stat-box{position:relative;isolation:isolate;' +
        'display:flex!important;align-items:flex-start!important;justify-content:flex-start!important;' +
        'text-align:left!important;min-width:0!important;width:100%!important;padding:24px!important;' +
        'border:1px solid rgba(255,255,255,.10)!important;border-radius:24px!important;' +
        'background:linear-gradient(145deg,rgba(255,255,255,.075),rgba(255,255,255,.018) 58%),' +
        'rgba(30,21,25,.82)!important;box-shadow:inset 0 1px 0 rgba(255,255,255,.13),' +
        'inset 0 -1px 0 rgba(255,75,126,.055),0 18px 44px rgba(0,0,0,.24)!important;' +
        'overflow:hidden!important;transform:none!important;transition:border-color .25s ease,' +
        'box-shadow .25s ease,transform .25s ease!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:before{content:"";position:absolute;z-index:-1;' +
        'width:190px;height:190px;border-radius:50%;right:-88px;top:-96px;pointer-events:none;' +
        'background:radial-gradient(circle,rgba(255,75,126,.22),transparent 68%)}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(2):before{' +
        'background:radial-gradient(circle,rgba(255,112,74,.22),transparent 68%)}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(3):before{' +
        'background:radial-gradient(circle,rgba(229,20,42,.21),transparent 68%)}' +
      '.mmServiceLogistik .st_benefits-stat-box:after{content:"";position:absolute;left:22px;right:22px;' +
        'top:0;height:1px;pointer-events:none;' +
        'background:linear-gradient(90deg,transparent,var(--mmSvcPink),var(--mmSvcOrange),transparent);opacity:.72}' +
      '.mmServiceLogistik .mmServiceIcon{display:grid;place-items:center;width:44px;height:44px;' +
        'flex:0 0 44px;margin:0 0 18px;border-radius:15px;color:var(--mmSvcPink);' +
        'border:1px solid rgba(255,75,126,.3);background:rgba(255,75,126,.1);' +
        'box-shadow:inset 0 1px 0 rgba(255,255,255,.13),0 10px 24px rgba(0,0,0,.18)}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(2) .mmServiceIcon{' +
        'color:var(--mmSvcOrange);border-color:rgba(255,112,74,.3);background:rgba(255,112,74,.1)}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(3) .mmServiceIcon{' +
        'color:#FF637A;border-color:rgba(229,20,42,.3);background:rgba(229,20,42,.1)}' +
      '.mmServiceLogistik .mmServiceIcon svg{display:block;width:23px;height:23px;fill:none;' +
        'stroke:currentColor;stroke-width:1.8;stroke-linecap:round;stroke-linejoin:round}' +
      '.mmServiceLogistik .st_benefits-stat-number,' +
      '.mmServiceLogistik .st_benefits-stat-number *{' +
        'font-family:"Bricolage Grotesque","MM Poppins Black",sans-serif!important;' +
        'font-size:clamp(3.35rem,5vw,4.55rem)!important;font-weight:800!important;' +
        'line-height:.85!important;letter-spacing:-.065em!important;margin:0!important;' +
        'background:linear-gradient(96deg,#FFFFFF 8%,var(--mmSvcPink) 58%,var(--mmSvcOrange));' +
        '-webkit-background-clip:text;background-clip:text;color:transparent!important}' +
      '.mmServiceLogistik .st_benefits-stat-number{display:flex!important;align-items:baseline!important;' +
        'justify-content:flex-start!important;margin:0 0 18px!important}' +
      '.mmServiceLogistik .st_benefits-stat-title{' +
        'font-family:"Bricolage Grotesque","Manrope",sans-serif!important;' +
        'font-size:clamp(1.05rem,1.6vw,1.25rem)!important;font-weight:800!important;' +
        'line-height:1.12!important;letter-spacing:-.028em!important;color:var(--mmSvcText)!important;' +
        'margin:0 0 11px!important;text-align:left!important}' +
      '.mmServiceLogistik .st_benefits-stat-description{' +
        'font-family:"Manrope",system-ui,sans-serif!important;font-size:.84rem!important;' +
        'font-weight:500!important;line-height:1.58!important;color:rgba(243,233,236,.63)!important;' +
        'margin:0!important;text-align:left!important;display:-webkit-box!important;' +
        '-webkit-box-orient:vertical;-webkit-line-clamp:4;overflow:hidden!important}' +
      '.mmServiceLogistik .st_benefits-stat-description.mmServiceFull{' +
        'display:block!important;overflow:visible!important}' +
      '.mmServiceLogistik .mmServiceMore{display:inline-flex;align-items:center;gap:8px;' +
        'min-height:40px;margin:14px 0 0;padding:8px 12px;border:1px solid rgba(255,255,255,.12);' +
        'border-radius:999px;background:rgba(255,255,255,.045);color:var(--mmSvcText);' +
        'font-family:"Manrope",system-ui,sans-serif;font-size:.73rem;font-weight:800;cursor:pointer}' +
      '.mmServiceLogistik .mmServiceMore:after{content:"+";display:grid;place-items:center;width:18px;height:18px;' +
        'border-radius:50%;background:linear-gradient(96deg,var(--mmSvcPink),var(--mmSvcOrange));' +
        'color:#fff;font-size:.78rem;line-height:1;transition:transform .25s ease}' +
      '.mmServiceLogistik .mmServiceMore[aria-expanded="true"]:after{content:"−";transform:rotate(180deg)}' +
      '.mmServiceLogistik .mmServiceMore:focus-visible{outline:2px solid var(--mmSvcPink);outline-offset:3px}' +
      '@media(hover:hover){.mmServiceLogistik .st_benefits-stat-box:hover{' +
        'transform:translateY(-4px)!important;border-color:rgba(255,75,126,.28)!important;' +
        'box-shadow:inset 0 1px 0 rgba(255,255,255,.15),0 22px 48px rgba(0,0,0,.3),' +
        '0 0 26px rgba(255,75,126,.07)!important}.mmServiceLogistik .mmServiceMore:hover{' +
        'border-color:rgba(255,75,126,.38);background:rgba(255,255,255,.075)}}' +
      '@media(max-width:767px){.mmServiceLogistik .st_benefits-stats-wrapper{' +
        'padding:30px 15px 34px!important}.mmServiceLogistik .st_benefits-stats-title{' +
        'font-size:clamp(2.05rem,11vw,2.75rem)!important;line-height:.95!important;' +
        'margin-bottom:20px!important}.mmServiceLogistik .st_benefits-stats-grid{' +
        'grid-template-columns:1fr!important;gap:12px!important}' +
      '.mmServiceLogistik .st_benefits-stat-box{display:grid!important;grid-template-columns:46px minmax(0,1fr);' +
        'column-gap:14px;row-gap:0;padding:18px!important;border-radius:20px!important}' +
      '.mmServiceLogistik .mmServiceIcon{grid-column:1;grid-row:1 / span 2;width:42px;height:42px;' +
        'margin:1px 0 0;border-radius:14px}.mmServiceLogistik .st_benefits-stat-number{' +
        'grid-column:2;grid-row:1;font-size:3rem!important;margin:0 0 8px!important}' +
      '.mmServiceLogistik .st_benefits-stat-number *{font-size:3rem!important}' +
      '.mmServiceLogistik .st_benefits-stat-title{grid-column:2;grid-row:2;font-size:1rem!important;' +
        'margin:0!important;align-self:start}.mmServiceLogistik .st_benefits-stat-description{' +
        'grid-column:1 / -1;grid-row:3;margin-top:15px!important;font-size:.78rem!important;' +
        'line-height:1.52!important;-webkit-line-clamp:3}' +
      '.mmServiceLogistik .mmServiceMore{grid-column:1 / -1;grid-row:4;justify-self:start;margin-top:12px}}' +
      '@media(prefers-reduced-motion:reduce){.mmServiceLogistik .st_benefits-stat-box,' +
        '.mmServiceLogistik .mmServiceMore:after{transition:none!important;' +
        'transform:none!important}}' +

      /* Service & Logistik hell: weisse Karten, dunkle Typografie und je Karte
         eine eigene Markenfarbe. Die kompakte Funktionalitaet bleibt gleich. */
      '.mmServiceLogistik{--mmSvcBg:#fff;--mmSvcCard:#fff;--mmSvcText:#171316;' +
        '--mmSvcMuted:#655D61;--mmSvcLine:#EDE3E6;background:#fff!important;color:var(--mmSvcText)}' +
      '.mmServiceLogistik .st_benefits-stats-wrapper{' +
        'background:radial-gradient(circle at 8% 0%,rgba(255,75,126,.08),transparent 32%),' +
        'radial-gradient(circle at 94% 100%,rgba(255,112,74,.07),transparent 30%),' +
        'linear-gradient(180deg,#fff 0%,#fff9fb 54%,#fff 100%)!important}' +
      '.mmServiceLogistik .st_benefits-stats-wrapper:before{opacity:.5;' +
        'background:linear-gradient(115deg,transparent 22%,rgba(255,75,126,.035) 50%,transparent 76%)}' +
      '.mmServiceLogistik .st_benefits-stats-title{' +
        'font-family:"MM Bricolage ExtraBold","Bricolage Grotesque","MM Poppins Black",sans-serif!important;' +
        'color:var(--mmSvcText)!important}' +
      '.mmServiceLogistik .st_benefits-stat-box{--mmSvcAccent:255,75,126;' +
        'border-color:rgba(var(--mmSvcAccent),.2)!important;' +
        'background:linear-gradient(145deg,rgba(var(--mmSvcAccent),.055),transparent 42%),#fff!important;' +
        'box-shadow:inset 0 1px 0 #fff,0 14px 34px rgba(64,27,38,.09)!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(2){--mmSvcAccent:255,112,74}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(3){--mmSvcAccent:229,20,42}' +
      '.mmServiceLogistik .st_benefits-stat-box:before{' +
        'background:radial-gradient(circle,rgba(var(--mmSvcAccent),.13),transparent 68%)!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:after{' +
        'background:linear-gradient(90deg,transparent,rgba(var(--mmSvcAccent),.86),transparent)!important;' +
        'opacity:.78}' +
      '.mmServiceLogistik .mmServiceIcon{color:rgb(var(--mmSvcAccent))!important;' +
        'border-color:rgba(var(--mmSvcAccent),.28)!important;' +
        'background:rgba(var(--mmSvcAccent),.075)!important;' +
        'box-shadow:inset 0 1px 0 #fff,0 8px 20px rgba(64,27,38,.08)!important}' +
      '.mmServiceLogistik .mmServiceIcon svg,.mmServiceLogistik .mmServiceIcon svg *{' +
        'color:inherit!important;fill:none!important;stroke:currentColor!important;stroke-width:1.8!important;' +
        'stroke-linecap:round!important;stroke-linejoin:round!important}' +
      '.mmServiceLogistik .st_benefits-stat-number,' +
      '.mmServiceLogistik .st_benefits-stat-number *{' +
        'font-family:"MM Bricolage ExtraBold","Bricolage Grotesque","MM Poppins Black",sans-serif!important;' +
        'background:linear-gradient(96deg,#171316 8%,rgb(var(--mmSvcAccent)) 68%)!important;' +
        '-webkit-background-clip:text!important;background-clip:text!important;color:transparent!important}' +
      '.mmServiceLogistik .st_benefits-stat-title{' +
        'font-family:"MM Bricolage ExtraBold","Bricolage Grotesque","Manrope",sans-serif!important;' +
        'color:var(--mmSvcText)!important}' +
      '.mmServiceLogistik .st_benefits-stat-description{color:var(--mmSvcMuted)!important}' +
      '.mmServiceLogistik .mmServiceMore{border-color:var(--mmSvcLine);background:#fff;' +
        'color:var(--mmSvcText);box-shadow:0 6px 16px rgba(64,27,38,.06)}' +
      '@media(min-width:768px){.mmServiceLogistik .st_benefits-stats-title{' +
        'font-size:clamp(2.45rem,5vw,4rem)!important}}' +
      '@media(hover:hover){.mmServiceLogistik .st_benefits-stat-box:hover{' +
        'border-color:rgba(var(--mmSvcAccent),.38)!important;' +
        'box-shadow:inset 0 1px 0 #fff,0 20px 42px rgba(var(--mmSvcAccent),.14)!important}' +
      '.mmServiceLogistik .mmServiceMore:hover{border-color:rgba(255,75,126,.32);' +
        'background:#fff8fa}}' +

      /* Service & Logistik 21st.dev-inspiriert: eine dominante Kennzahl,
         zwei ruhige Nebenflaechen, ein Akzent und keine dekorativen Glows. */
      '.mmServiceLogistik{--mmSvcInk:#171316;--mmSvcPaper:#F7F7F5;--mmSvcSurface:#FFFFFF;' +
        '--mmSvcLine:#DCD9DA;--mmSvcMuted:#666164;--mmSvcAccent:#E5142A;' +
        'background:var(--mmSvcPaper)!important;color:var(--mmSvcInk)!important}' +
      '.mmServiceLogistik .st_benefits-stats-wrapper{' +
        'padding:clamp(2rem,5vw,4.5rem) clamp(1rem,4vw,3rem)!important;' +
        'background:var(--mmSvcPaper)!important;overflow:hidden!important}' +
      '.mmServiceLogistik .st_benefits-stats-wrapper:before{display:none!important}' +
      '.mmServiceLogistik .st_benefits-stats-container{max-width:1120px!important}' +
      '.mmServiceLogistik .st_benefits-stats-title{' +
        'max-width:900px!important;margin:0 0 clamp(1.5rem,3vw,2.5rem)!important;' +
        'font-family:"MM Bricolage ExtraBold","Bricolage Grotesque","MM Poppins Black",sans-serif!important;' +
        'font-size:clamp(2.4rem,5.2vw,4.25rem)!important;font-weight:800!important;' +
        'line-height:.96!important;letter-spacing:-.055em!important;text-transform:uppercase!important;' +
        'text-align:left!important;color:var(--mmSvcInk)!important}' +
      '.mmServiceLogistik .st_benefits-stats-title:before{display:none!important}' +
      '.mmServiceLogistik .st_benefits-stats-title span,' +
      '.mmServiceLogistik .st_benefits-stats-title em{' +
        'font:inherit!important;font-style:normal!important;color:inherit!important;' +
        'background:none!important;-webkit-text-fill-color:currentColor!important}' +
      '.mmServiceLogistik .st_benefits-stats-grid{' +
        'display:grid!important;grid-template-columns:minmax(0,1.25fr) minmax(280px,.75fr)!important;' +
        'grid-template-rows:repeat(2,minmax(0,1fr))!important;gap:14px!important;' +
        'align-items:stretch!important;margin:0!important}' +
      '.mmServiceLogistik .st_benefits-stat-box{' +
        'display:flex!important;flex-direction:column!important;align-items:flex-start!important;' +
        'justify-content:flex-start!important;width:100%!important;min-width:0!important;' +
        'padding:clamp(1.35rem,2.7vw,2.35rem)!important;border:1px solid var(--mmSvcLine)!important;' +
        'border-radius:18px!important;background:var(--mmSvcSurface)!important;' +
        'box-shadow:none!important;overflow:hidden!important;transform:none!important;' +
        'transition:border-color .2s ease,transform .2s ease!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child{' +
        'grid-column:1;grid-row:1 / span 2;min-height:430px;' +
        'border-color:var(--mmSvcInk)!important;background:var(--mmSvcInk)!important;' +
        'color:#F8F6F7!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(2){grid-column:2;grid-row:1}' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(3){grid-column:2;grid-row:2}' +
      '.mmServiceLogistik .st_benefits-stat-box:before,' +
      '.mmServiceLogistik .st_benefits-stat-box:after{display:none!important}' +
      '.mmServiceLogistik .mmServiceIcon{display:none!important}' +
      '.mmServiceLogistik .st_benefits-stat-number,' +
      '.mmServiceLogistik .st_benefits-stat-number *{' +
        'font-family:"MM Bricolage ExtraBold","Bricolage Grotesque","MM Poppins Black",sans-serif!important;' +
        'font-size:clamp(3.6rem,6.2vw,5.4rem)!important;font-weight:800!important;' +
        'font-variant-numeric:tabular-nums!important;line-height:.88!important;' +
        'letter-spacing:-.07em!important;color:var(--mmSvcInk)!important;' +
        'background:none!important;-webkit-text-fill-color:currentColor!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-number,' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-number *{' +
        'font-size:clamp(5rem,10vw,8.5rem)!important;color:#F8F6F7!important}' +
      '.mmServiceLogistik .st_benefits-stat-number{' +
        'display:flex!important;align-items:baseline!important;justify-content:flex-start!important;' +
        'margin:0 0 14px!important}' +
      '.mmServiceLogistik .st_benefits-stat-title{' +
        'max-width:22ch!important;margin:0 0 10px!important;' +
        'font-family:"MM Bricolage ExtraBold","Bricolage Grotesque","Manrope",sans-serif!important;' +
        'font-size:clamp(1.05rem,1.8vw,1.4rem)!important;font-weight:800!important;' +
        'line-height:1.08!important;letter-spacing:-.035em!important;text-align:left!important;' +
        'color:var(--mmSvcInk)!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-title{' +
        'font-size:clamp(1.35rem,2.5vw,1.9rem)!important;color:#F8F6F7!important}' +
      '.mmServiceLogistik .st_benefits-stat-description{' +
        'margin:0!important;font-family:"Manrope",system-ui,sans-serif!important;' +
        'font-size:.86rem!important;font-weight:500!important;line-height:1.5!important;' +
        'text-align:left!important;color:var(--mmSvcMuted)!important;' +
        'display:-webkit-box!important;-webkit-box-orient:vertical;-webkit-line-clamp:3;' +
        'overflow:hidden!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-description{' +
        'max-width:56ch;color:rgba(248,246,247,.72)!important;-webkit-line-clamp:5}' +
      '.mmServiceLogistik .st_benefits-stat-description.mmServiceFull{' +
        'display:block!important;overflow:visible!important}' +
      '.mmServiceLogistik .mmServiceMore{' +
        'display:inline-flex!important;align-items:center!important;min-height:38px!important;' +
        'margin:auto 0 0!important;padding:8px 12px!important;border:1px solid var(--mmSvcLine)!important;' +
        'border-radius:10px!important;background:transparent!important;color:var(--mmSvcInk)!important;' +
        'box-shadow:none!important;font-family:"Manrope",system-ui,sans-serif!important;' +
        'font-size:.76rem!important;font-weight:750!important;cursor:pointer}' +
      '.mmServiceLogistik .mmServiceMore:after{display:none!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .mmServiceMore{' +
        'border-color:rgba(255,255,255,.3)!important;color:#F8F6F7!important}' +
      '.mmServiceLogistik .mmServiceMore:focus-visible{' +
        'outline:2px solid var(--mmSvcAccent)!important;outline-offset:3px!important}' +
      '@media(hover:hover){.mmServiceLogistik .st_benefits-stat-box:hover{' +
        'transform:translateY(-2px)!important;border-color:#A9A4A6!important;box-shadow:none!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child:hover{' +
        'border-color:var(--mmSvcInk)!important}.mmServiceLogistik .mmServiceMore:hover{' +
        'background:#F0EEEF!important;border-color:#BEBABC!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .mmServiceMore:hover{' +
        'background:rgba(255,255,255,.09)!important;border-color:rgba(255,255,255,.5)!important}}' +
      '@media(max-width:767px){.mmServiceLogistik .st_benefits-stats-wrapper{' +
        'padding:30px 15px 34px!important}.mmServiceLogistik .st_benefits-stats-title{' +
        'font-size:clamp(2.25rem,10.5vw,2.75rem)!important;line-height:.95!important;' +
        'margin-bottom:18px!important}.mmServiceLogistik .st_benefits-stats-grid{' +
        'grid-template-columns:1fr!important;grid-template-rows:auto!important;gap:10px!important}' +
      '.mmServiceLogistik .st_benefits-stat-box,' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child,' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(2),' +
      '.mmServiceLogistik .st_benefits-stat-box:nth-child(3){' +
        'grid-column:1!important;grid-row:auto!important;min-height:0!important;' +
        'padding:20px!important;border-radius:16px!important}' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-number,' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-number *{' +
        'font-size:4.65rem!important}.mmServiceLogistik .st_benefits-stat-number,' +
      '.mmServiceLogistik .st_benefits-stat-number *{font-size:3.35rem!important}' +
      '.mmServiceLogistik .st_benefits-stat-title,' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-title{' +
        'font-size:1.05rem!important;margin-bottom:8px!important}' +
      '.mmServiceLogistik .st_benefits-stat-description,' +
      '.mmServiceLogistik .st_benefits-stat-box:first-child .st_benefits-stat-description{' +
        'font-size:.79rem!important;line-height:1.48!important;-webkit-line-clamp:2}' +
      '.mmServiceLogistik .mmServiceMore{margin:14px 0 0!important}}' +
      '@media(prefers-reduced-motion:reduce){.mmServiceLogistik .st_benefits-stat-box{' +
        'transition:none!important;transform:none!important}}';
    (document.head || document.documentElement).appendChild(style);
  }

  var observer = null;
  function showSteps(node) {
    node.classList.add('mmStepsMotionIn');
    if (observer) observer.unobserve(node);
  }

  function prepareSteps(node) {
    if (!node || node.getAttribute('data-mm-steps-polish') === '1') return;
    node.setAttribute('data-mm-steps-polish', '1');
    node.classList.add('mmStepsModern');
    if (reduced || !('IntersectionObserver' in window)) {
      node.classList.add('mmStepsMotionIn');
      return;
    }
    node.classList.add('mmStepsMotionPending');
    if (!observer) {
      observer = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i += 1) {
          if (entries[i].isIntersecting) showSteps(entries[i].target);
        }
      }, { threshold: 0.22, rootMargin: '0px 0px -8% 0px' });
    }
    observer.observe(node);
    window.setTimeout(function () {
      if (node.isConnected && !node.classList.contains('mmStepsMotionIn')) showSteps(node);
    }, 30000);
  }

  function prepareService(section) {
    if (!section || section.getAttribute('data-mm-service-polish') === '1') return;
    var wrapper = section.querySelector('.st_benefits-stats-wrapper');
    var title = section.querySelector('.st_benefits-stats-title');
    var cards = section.querySelectorAll('.st_benefits-stat-box');
    if (!wrapper || !title || !cards.length) return;

    section.setAttribute('data-mm-service-polish', '1');
    section.classList.add('mmServiceLogistik');
    if (/^\s*Service\s*&\s*Logistik\s*$/i.test(title.textContent || '')) {
      title.setAttribute('aria-label', 'Service & Logistik');
      title.innerHTML = '<span>SERVICE &amp;</span> <em>LOGISTIK</em>';
    }

    for (var i = 0; i < cards.length; i += 1) {
      var card = cards[i];
      var description = card.querySelector('.st_benefits-stat-description');
      if (!description) continue;

      var descriptionId = 'mm-service-detail-' + i;
      description.id = descriptionId;
      var button = document.createElement('button');
      button.className = 'mmServiceMore';
      button.type = 'button';
      button.setAttribute('aria-expanded', 'false');
      button.setAttribute('aria-controls', descriptionId);
      button.textContent = 'Mehr anzeigen';
      card.appendChild(button);

      (function (control, text, box) {
        control.addEventListener('click', function () {
          var open = control.getAttribute('aria-expanded') === 'true';
          control.setAttribute('aria-expanded', open ? 'false' : 'true');
          control.textContent = open ? 'Mehr anzeigen' : 'Weniger anzeigen';
          text.classList.toggle('mmServiceFull', !open);
          box.classList.toggle('mmServiceOpen', !open);
        });
      })(button, description, card);
    }
  }

  function apply() {
    addStyle();
    var ingredientSections = document.querySelectorAll('.shopify-section[id*="__ss_feature_24_"]');
    for (var i = 0; i < ingredientSections.length; i += 1) {
      ingredientSections[i].classList.add('mmIngredientGradient');
      var featureTitles = ingredientSections[i].querySelectorAll('[class*="feature-title-"]');
      for (var k = 0; k < featureTitles.length; k += 1) {
        featureTitles[k].classList.add('mmIngredientHeading');
      }
      var sectionHeadings = ingredientSections[i].querySelectorAll('[class*="feature-heading-"] > *');
      for (var h = 0; h < sectionHeadings.length; h += 1) {
        var sectionHeading = sectionHeadings[h];
        sectionHeading.classList.remove('mmIngredientHeading');
        sectionHeading.classList.add('mmIngredientSectionHeading');
        var sectionHeadingText = String(sectionHeading.textContent || '').replace(/\s+/g, ' ').trim();
        if (/^Die Kraft und Wirkung der Zutaten in Magic Milk$/i.test(sectionHeadingText) &&
            sectionHeading.getAttribute('data-mm-title-lines') !== '3') {
          sectionHeading.setAttribute('data-mm-title-lines', '3');
          sectionHeading.setAttribute('aria-label', 'Die Kraft und Wirkung der Zutaten in Magic Milk');
          sectionHeading.innerHTML =
            '<strong>' +
              '<span class="mmIngredientTitleLine">Die Kraft und</span>\n' +
              '<span class="mmIngredientTitleLine">Wirkung der Zutaten</span>\n' +
              '<span class="mmIngredientTitleLine">in Magic Milk</span>' +
            '</strong>';
        }
      }
    }
    var stepTitles = document.querySelectorAll('.st_hiw-title');
    for (var j = 0; j < stepTitles.length; j += 1) {
      if (/Mehr Energie\s*&\s*Appetit in\s*3 Steps/i.test(stepTitles[j].textContent || '')) {
        prepareSteps(stepTitles[j]);
      }
    }
    var serviceSections = document.querySelectorAll('.shopify-section[id*="st_stats_benefits"]');
    for (var s = 0; s < serviceSections.length; s += 1) prepareService(serviceSections[s]);
  }

  function start() {
    apply();
    var runs = 0;
    var timer = window.setInterval(function () {
      apply();
      runs += 1;
      if (runs >= 12) window.clearInterval(timer);
    }, 500);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', apply);
})();
